import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import routes from '@/routes';
import { getRouteKeyByPath } from '@/helpers/routes';
import { useSelector } from 'react-redux';

export default function useRouteGuard(allowallowedRoutes, userType) {
  const location = useLocation();
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state.user.accessToken);

  useEffect(() => {
    const currentPath = location.pathname;
    const publicPaths = [routes.login.path];

    if (!accessToken) {
      navigate(routes.login.path, { replace: true });
      return;
    }

    if (publicPaths.includes(currentPath)) {
      return;
    }

    const currentRouteKey = getRouteKeyByPath(currentPath);

    if (!currentRouteKey || !allowallowedRoutes.includes(currentRouteKey)) {
      navigate('/');
    }
  }, [location.pathname, allowallowedRoutes, userType, navigate]);
}
